import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'pr-image-viewer',
    templateUrl: './pr-image-viewer.component.html',
    styleUrls: ['./pr-image-viewer.component.scss'],
    standalone: false
})
export class PrImageViewerComponent implements OnInit {
  @Input() open: boolean;
  @Input() imageURL: string;
  @Output() close = new EventEmitter();
  constructor() {}

  ngOnInit(): void {}
}
